/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface SpoofBatteryLevelActionArgs {
  /** Battery level to be spoofed in range [0, 1] */
  batteryLevel: number;
}

export interface SpoofBatteryLevelResultData {
}

export interface SpoofBatteryLevelActionStateData {
}

function createBaseSpoofBatteryLevelActionArgs(): SpoofBatteryLevelActionArgs {
  return { batteryLevel: 0 };
}

export const SpoofBatteryLevelActionArgs = {
  encode(message: SpoofBatteryLevelActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.batteryLevel !== 0) {
      writer.uint32(13).float(message.batteryLevel);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofBatteryLevelActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofBatteryLevelActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.batteryLevel = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofBatteryLevelActionArgs {
    return { batteryLevel: isSet(object.batteryLevel) ? globalThis.Number(object.batteryLevel) : 0 };
  },

  toJSON(message: SpoofBatteryLevelActionArgs): unknown {
    const obj: any = {};
    if (message.batteryLevel !== 0) {
      obj.batteryLevel = message.batteryLevel;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofBatteryLevelActionArgs>, I>>(base?: I): SpoofBatteryLevelActionArgs {
    return SpoofBatteryLevelActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofBatteryLevelActionArgs>, I>>(object: I): SpoofBatteryLevelActionArgs {
    const message = createBaseSpoofBatteryLevelActionArgs();
    message.batteryLevel = object.batteryLevel ?? 0;
    return message;
  },
};

function createBaseSpoofBatteryLevelResultData(): SpoofBatteryLevelResultData {
  return {};
}

export const SpoofBatteryLevelResultData = {
  encode(_: SpoofBatteryLevelResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofBatteryLevelResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofBatteryLevelResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofBatteryLevelResultData {
    return {};
  },

  toJSON(_: SpoofBatteryLevelResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofBatteryLevelResultData>, I>>(base?: I): SpoofBatteryLevelResultData {
    return SpoofBatteryLevelResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofBatteryLevelResultData>, I>>(_: I): SpoofBatteryLevelResultData {
    const message = createBaseSpoofBatteryLevelResultData();
    return message;
  },
};

function createBaseSpoofBatteryLevelActionStateData(): SpoofBatteryLevelActionStateData {
  return {};
}

export const SpoofBatteryLevelActionStateData = {
  encode(_: SpoofBatteryLevelActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofBatteryLevelActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofBatteryLevelActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofBatteryLevelActionStateData {
    return {};
  },

  toJSON(_: SpoofBatteryLevelActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofBatteryLevelActionStateData>, I>>(
    base?: I,
  ): SpoofBatteryLevelActionStateData {
    return SpoofBatteryLevelActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofBatteryLevelActionStateData>, I>>(
    _: I,
  ): SpoofBatteryLevelActionStateData {
    const message = createBaseSpoofBatteryLevelActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
